<template>
    <div>
        <b-modal
            v-model="importModal"
            size="xl"
            hide-footer
            no-close-on-backdrop
        >
            <import-orders-form
                @success="importModal = false"
                @cancel="importModal = false"
            />
        </b-modal>

        <b-container fluid class="mt--7">
            <b-row>
                <b-col>
                    <order-table
                        title="Users"
                        @add="addModal = true"
                        @import="importModal = true"
                        ref="table"
                    >
                    </order-table>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import OrderTable from './OrderTable'
import ImportOrdersForm from './ImportOrdersForm'

export default {
    name: 'orders',
    mixins: [popupMixins, permissionsMixins],
    components: {
        OrderTable,

        ImportOrdersForm,
    },
    data: () => {
        return {
            componentName: 'Order',
            addModal: false,
            importModal: false,
        }
    },
    created() {
        console.log('fetching users')
        this.$store.dispatch('checkoffTypes/fetchAll')

        this.$store.dispatch('roles/fetchAll')
        this.$store.dispatch('requestCategory/fetchAll')
        this.$store.dispatch('orderType/fetchAll')

        this.$store.dispatch('users/fetchAll')
    },

    methods: {
        orderCreated() {
            this.addModal = false
            this.$refs.table.doSearch(true)

            this.genericToast(
                this.componentName,
                'Created',
                'success',
                'Activity created successfully '
            )
            //this.doToast('Success', `Order Created`, 'success')
        },
    },
}
</script>
